module.exports = __webpack_public_path__ + "img/pasta_a_la_vodka_prep.8f7420ab.jpg";